import CredentialsProvider from "next-auth/providers/credentials";
import NextAuth, {NextAuthOptions, getServerSession} from 'next-auth';
import type {
  GetServerSidePropsContext,
  NextApiRequest,
  NextApiResponse,
} from "next";
import { getUserToken } from "./utils/api";
import { Session } from '@/lib/types'

const authOptions: NextAuthOptions = {
    // https://next-auth.js.org/configuration/providers/oauth
    
    providers: [
        CredentialsProvider({
            name: "Credentials",
        // `credentials` is used to generate a form on the sign in page.
        // You can specify which fields should be submitted, by adding keys to the `credentials` object.
        // e.g. domain, username, password, 2FA token, etc.
        // You can pass any HTML attribute to the <input> tag through the object.
        credentials: {
            username: { label: "Username", type: "email"},
            password: { label: "Password", type: "password" }
        },

        async authorize(credentials, req) {
            const {username, password } = credentials as {username: string, password: string};

            const user = await getUserToken(username, password)
            // Add logic here to look up the user from the credentials supplied      
            if (user) {
              // Any object returned will be saved in `user` property of the JWT
              return user
            } else {
              // If you return null then an error will be displayed advising the user to check their details.
              return null
      
              // You can also Reject this callback with an Error thus the user will be sent to the error page with the error message as a query parameter
            }
          }
        }),
    ],
    pages: {
        signIn: '/login',
        signOut: '/logout',
        error: '/login',
        newUser: '/sign-up',
    },
    callbacks: {
        async session({  session, user, token }) {
          // Add property to session, like an access_token from a provider.
          // TODO: Add logic to get more user details from the user object

          // session is the current session object
          // user is the ?????
          // token looks like the current user object fetched from the authorize function
          return token ? { ...session, ...token } : session;
        },
        async jwt({ token, user }) {
          return user ? { ...token, ...user } : token;
        },
    }
  };
  

// Use it in server contexts
export function auth(
  ...args:
    | [GetServerSidePropsContext["req"], GetServerSidePropsContext["res"]]
    | [NextApiRequest, NextApiResponse]
    | []
) : Promise<Session | null>
{
  return getServerSession(...args, authOptions)
}

const handler = NextAuth(authOptions);
export { handler as GET, handler as POST };
